import React, { useState, useContext, useEffect, useRef } from 'react'
import Button from 'react-bootstrap/Button'
import { CgMenuLeftAlt } from 'react-icons/cg'
import { useLazyQuery } from '@apollo/client'
import { Link, useHistory } from 'react-router-dom'

import AppContext from '../../context'
import Logo from '../../assets/images/logo.png'
import { MyEvent, Notification, authModalType } from '../../types'
import { GET_ALL_EVENTS } from '../../graphql'
import { salmon } from '../../styles/themeColors'
import { useCurrentUser } from '../../common'
import { SigninSignup } from '../../components'
import { myHub } from '../../common/constants'
import { Avatar } from '../Avatar'

import { MobileMenu, MobileMenuBody } from './style'
import { Submenu, Notifications } from './components'

interface IMobileNavbar {
  openHowWeWork: React.Dispatch<React.SetStateAction<boolean>>
  handleLogin?: (type?: authModalType) => void
  list?: Notification[]
}

export const MobileNavbar: React.FC<IMobileNavbar> = ({
  openHowWeWork,
  handleLogin,
  list,
}) => {
  const history = useHistory()
  const { isAuthenticated } = useCurrentUser()
  const [getMyEvents, { data }] = useLazyQuery(GET_ALL_EVENTS)

  const [openMenu, setOpenMenu] = useState(false)
  const [openLogin, setOpenLogin] = useState(false)
  const [expandedSubmenu, setExpandedSubmenu] = useState(false)
  const [openMenuUser, setOpenMenuUser] = useState(false)
  const { auth } = useContext(AppContext)

  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (isAuthenticated) {
      getMyEvents()
    }

    document.addEventListener('mousedown', ev => {
      if (!menuRef.current?.contains(ev.target as Node)) {
        setOpenMenuUser(false)
        setOpenMenu(false)
      }
    })
  }, [getMyEvents, isAuthenticated])

  const isMobile = window.matchMedia('(max-width: 991px)').matches
  if (!isMobile) return null

  const toggleMenu = () => {
    setOpenMenuUser(false)
    setOpenMenu(!openMenu)
  }
  const toggleMenuUser = () => {
    setOpenMenu(false)
    setOpenMenuUser(!openMenuUser)
  }

  const howWeWork = (ev: React.MouseEvent) => {
    ev.preventDefault()
    openHowWeWork(true)
    toggleMenu()
  }
  const handleLogout = (ev: React.MouseEvent) => {
    ev.preventDefault()
    auth.signOut()
    history.push('/')
  }

  const handleMyHub = (ev: React.MouseEvent) => {
    ev.preventDefault()
    toggleMenu()
    if (isAuthenticated) {
      history.push(myHub)
    } else {
      setOpenLogin(true)
    }
  }

  const myEvents: MyEvent[] = data?.me?.myEventList || []
  return (
    <MobileMenu className="d-flex d-lg-none" ref={menuRef}>
      <SigninSignup open={openLogin} onClose={() => setOpenLogin(false)} />
      <div className="mr-auto">
        <CgMenuLeftAlt
          size={30}
          color={salmon}
          style={{ marginRight: isAuthenticated ? '44px' : '10px' }}
          onClick={toggleMenu}
        />
      </div>
      <Link to="/" className="mx-auto d-block">
        <img src={Logo} alt="Kiss and Tell" width="134" />
      </Link>
      <div className="ml-auto d-flex">
        {isAuthenticated && list && <Notifications list={list} />}
        <a onClick={toggleMenuUser}>
          <Avatar
            size="30x30"
            defaultSize={30}
            defaultColor={salmon}
            className="rounded-circle ml-3"
          />
        </a>
      </div>

      <MobileMenuBody
        className={`
        ${openMenu ? 'show' : ''}
        ${expandedSubmenu ? 'expandedSubmenu' : ''}
      `}
      >
        <Link onClick={handleMyHub} to="/">
          My Hub
        </Link>
        <Link onClick={toggleMenu} to="/blog">
          Inspiration
        </Link>
        <Link onClick={toggleMenu} to="/marketplace">
          Wedding Destinations
        </Link>
        <a onClick={howWeWork}>How We Work</a>

        {isAuthenticated && (
          <Submenu
            title="Manage Events"
            expandedSubmenu={setExpandedSubmenu}
            events={myEvents}
            toggleMenu={toggleMenu}
          />
        )}
      </MobileMenuBody>

      <MobileMenuBody className={openMenuUser ? 'show-user' : ''}>
        {isAuthenticated && (
          <>
            <Link onClick={toggleMenuUser} to="/manage-profile">
              Manage profile
            </Link>
            <a href="logout" onClick={handleLogout}>
              Logout
            </a>
          </>
        )}
        {!isAuthenticated && (
          <div className="pt-4 pb-2 mx-auto" style={{ maxWidth: '500px' }}>
            <Button
              onClick={() => handleLogin?.('login')}
              className="w-100 bradius-1"
            >
              Login
            </Button>
          </div>
        )}
      </MobileMenuBody>
    </MobileMenu>
  )
}
